import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from '../../../Components/MUIs';
import BottomSheet from '../../../Components/Ui/BottomSheet';
import Icon from '../../../Assets/Icon/CustomIcon';
import { ArrowForwardIos as RightArrowIcon } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  resetSearchInfo,
  setCustCd,
  setDepCd,
} from '../../../Reducer/SearchReducer';
import { PermitActions } from '../../../Reducer/PermitReducer';
import { BottomSheetActions } from '../../../Reducer/BottomSheetReducer';

export default function FilterBottomSheet({ SearchLogic1 }) {
  const [mode, setMode] = useState('main');
  const dispatch = useDispatch();

  const searchInfo = useSelector((state) => state.searchInfo);
  const { selectedFilter, filterLabels } = useSelector((state) => state.permit);

  const extendedDepList = [
    { name: '전체', value: '' },
    ...(searchInfo.depList || []),
  ];

  return (
    <BottomSheet
      isHeaderChildren={true}
      headerText={mode === 'main' ? '필터' : ''}
      headerChildren={
        <>
          {mode === 'main' ? (
            <button
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={() => dispatch(resetSearchInfo())}
            >
              <Icon.Refresh />
            </button>
          ) : (
            <Box
              sx={{ display: 'flex', alignItems: 'center' }}
              onClick={() => setMode('main')}
            >
              <button
                style={{
                  backgroundColor: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  paddingRight: '0.3rem',
                }}
              >
                <RightArrowIcon
                  style={{ transform: 'rotate(180deg)', width: '20px' }}
                />
              </button>
              <Typography
                sx={{ py: 2, pr: 1, color: '#3A3A3A', fontSize: '18px' }}
              >
                {mode === 'cust' ? '사업장 선택' : '부서 선택'}
              </Typography>
            </Box>
          )}
        </>
      }
    >
      <Box
        p={1}
        bgcolor="#fff"
        sx={{
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        {mode === 'main' && (
          <>
            <button
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
              onClick={() => setMode('dep')}
            >
              <Typography>부서</Typography>
              <Icon.BottomArrow style={{ transform: 'rotate(-90deg)' }} />
            </button>

            <Box
              style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
            >
              <Typography>상태</Typography>
              <Box style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                {filterLabels.map((label) => (
                  <button
                    key={label}
                    onClick={() =>
                      dispatch(PermitActions.setSelectedFilter(label))
                    }
                    style={{
                      backgroundColor: 'transparent',
                      border: '1px solid',
                      borderColor:
                        selectedFilter === label ? '#7079DF' : '#C3BBBB',
                      borderRadius: '0.7rem',
                      padding: '2px 8px',
                      cursor: 'pointer',
                      color: selectedFilter === label ? '#7079DF' : '#B1A6A6',
                      fontSize: '0.8rem',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {label}
                  </button>
                ))}
              </Box>
            </Box>

            <Button
              name="확인"
              sx={{
                width: '100%',
                height: 36,
                borderRadius: '5px',
                backgroundColor: '#57B84D',
                color: '#fff',
              }}
              onClick={() => {
                dispatch(BottomSheetActions.CloseBottomSheet());
                SearchLogic1();
              }}
            />
          </>
        )}

        {(mode === 'cust' || mode === 'dep') && (
          <Box style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            {(mode === 'cust' ? searchInfo.custList : extendedDepList).map(
              (item) => (
                <button
                  key={item.value}
                  onClick={() => {
                    dispatch(
                      mode === 'cust'
                        ? setCustCd(item.value)
                        : setDepCd(item.value)
                    );
                    setMode('main');
                  }}
                  style={{
                    backgroundColor:
                      (mode === 'cust'
                        ? searchInfo.custCd
                        : searchInfo.depCd) === item.value
                        ? '#E6EBFF'
                        : 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    textAlign: 'left',
                    padding: '4px 8px',
                    borderRadius: '5px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  }}
                >
                  {item.name}
                </button>
              )
            )}
          </Box>
        )}
      </Box>
    </BottomSheet>
  );
}
